import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './web/components/login/login.component';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [


  { component: LoginComponent, path: '' },

  {
    path: 'pdg', canLoad: [ AuthGuard ], canActivate: [ AuthGuard ],
    loadChildren: () => import('./web/web.module').then( m => m.WebModule )
  },

  { path: '**', redirectTo: ''},
  { path: '', pathMatch: 'full', redirectTo: '' },


];
@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules , useHash: false , scrollPositionRestoration: 'top'} )],
  exports: [RouterModule],
})
export class AppRoutingModule {}
